import * as echarts from "echarts";
import { useEffect, useRef } from "react";
import { buildChartOptions } from "../helpers/recipeImpactChart.builder.helper";
import { ChartSourceData } from "../recipeImpactChart.types";

/**
 * Owns the ECharts instance lifecycle for the recipe impact chart.
 *
 * All data shaping lives in the pure `buildChartOptions` builder; this hook is
 * responsible only for the side effect of initialising, updating and disposing
 * the chart whenever the source data changes.
 *
 * @returns a ref to attach to the chart container element.
 */
export const useRecipeImpactChart = ({
  recipeResults,
  originalRecipeData,
  selectedVariants
}: ChartSourceData) => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const chart = echarts.init(chartRef.current);
    chart.setOption(buildChartOptions({ recipeResults, originalRecipeData, selectedVariants }));

    return () => {
      chart.dispose();
    };
  }, [recipeResults, originalRecipeData, selectedVariants]);

  return chartRef;
};
